<template>
  <Event />
</template>

<script>
import Event from '@/components/EVENT/event.vue';

export default {
  name: 'EventView',
  components: {
    Event,
  },
}
</script>
